import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'allas-price-display',
  imports: [CommonModule],
  template: `
    <div class="flex items-baseline">
      <!-- Símbolo de moneda (L.) -->
      <span class="text-xs text-gray-900 mr-1 relative -top-[4px]">L.</span>

      <!-- Precio principal -->
      <div class="flex items-baseline">
        <!-- Parte entera del precio -->
        <span class="text-lg font-bold text-gray-900">{{ integerPart }}</span>

        <!-- Parte decimal un poquito arriba -->
        <span
          class="text-xs font-bold text-gray-900 relative -top-[6px] leading-none"
        >
          {{ decimalPart }}
        </span>
      </div>
    </div>
  `,
  styles: [
    `
      .leading-none {
        line-height: 1;
      }
    `,
  ],
})
export class PriceDisplayComponent {
  @Input() price!: number;

  get integerPart(): string {
    const integer = Math.floor(this.price);
    return integer.toLocaleString('en-US');
  }

  get decimalPart(): string {
    const decimal = (this.price % 1).toFixed(2).substring(2);
    return decimal;
  }
}
